var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C16 12.6421 12.7107 16 8.65309 16H1.30615V8.5C1.30615 4.35786 4.59548 1 8.65309 1C12.7107 1 16 4.35786 16 8.5Z",
    fill: "#2970FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.5C16 19.3579 19.2893 16 23.3469 16H30.6939V23.5C30.6939 27.6421 27.4045 31 23.3469 31C19.2893 31 16 27.6421 16 23.5Z",
    fill: "#2970FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30615 23.5C1.30615 27.6421 4.59548 31 8.65309 31H16V23.5C16 19.3579 12.7107 16 8.65309 16C4.59548 16 1.30615 19.3579 1.30615 23.5Z",
    fill: "#2970FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6939 8.5C30.6939 4.35786 27.4045 1 23.3469 1H16V8.5C16 12.6421 19.2893 16 23.3469 16C27.4045 16 30.6939 12.6421 30.6939 8.5Z",
    fill: "#2970FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c2ab16e79789034e12663476d84b1e9d.svg";
export { ForwardRef as ReactComponent };